import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"
import { Outlet, useParams, useLocation, useNavigate } from "react-router-dom"
import { Spin } from "antd"
import "./index.scss"
import { useMe } from "@/hooks";
import { getIthPopApi, getIthWhiteListApi, getIthWorktimeApi, addIthPopLogApi, getIthPopStatusApi } from "@/services"
import { useRequest } from "ahooks"
import { ThEmpty } from '@/components';
import { documentUtil } from "@/utils"
import plmLogo from "@/assets/plm-logo-w.png"
import { isDev } from "@/config/common"
import ProjectReview from "./projectReview"

interface ITabItem {
    title: string
    type: string
    url?: string
    log: string
    flag?: boolean
    /** 非 iframe 的标签页内容，存在时优先渲染该组件 */
    content?: React.ReactNode
}
const Index = () => {
    const [tabItemList, setTabItemList] = useState<ITabItem[]>([])
    const [searchParams, setSearchParams] = useSearchParams()
    const [tabItem, setTabItem] = useState<ITabItem>()
    const [loading, setLoading] = useState(false)

    const [ithloading, setIthloading] = useState(false)
    const [plmloading, setplmloading] = useState(false)

    const { data: user, loading: userLoading } = useMe()

    const { run: addLog } = useRequest(addIthPopLogApi, {
        manual: true,
    })

    useEffect(() => {
        if (!user) return
        const email = user.email
        const username = email.split('@')[0];
        let tabs: ITabItem[] = []
        const getIthData = async () => {
            setIthloading(true)
            try {
                const res = await getIthPopApi(username)
                const statusRes = await getIthPopStatusApi()
                let isOpen = res.isOpen || statusRes.isOpen
                let leadIsOpen = res.leadIsOpen || statusRes.leadIsOpen
                let isLeadMilestoneIsOpen = res.isLeadMilestoneIsOpen || statusRes.isLeadMilestoneIsOpen

                if (isOpen) {
                    //专负
                    tabs.push({
                        title: "工时审批-专业负责人",
                        type: "zc_approve",
                        log: "工时审批-专业负责人",
                        url: res.url,
                        flag: res.isOpen
                    })
                }
                if (leadIsOpen) {
                    //设总
                    tabs.push({
                        title: "工时审批-设总/主创",
                        type: "sz_approve",
                        log: "工时审批-设总",
                        url: res.leadUrl,
                        flag: res.leadIsOpen
                    })
                }
                if (isLeadMilestoneIsOpen) {
                    //里程碑
                    tabs.push({
                        title: "里程碑计划更新",
                        type: "milestone",
                        log: "里程碑计划：按钮点击",
                        url: res.leadMilestoneUrl,
                        flag: res.isLeadMilestoneIsOpen
                    })
                }
            } catch (error) {

            } finally {
                // 项目毛利复盘：无条件显示（即使上方接口异常/暂无数据，左侧菜单也必须展示）
                if (!tabs.some(v => v.type === "project_review")) {
                    tabs.push({
                        title: "项目毛利复盘",
                        type: "project_review",
                        log: "项目毛利复盘",
                        content: <ProjectReview />,
                    })
                }
                setTabItemList([...tabs])
                if (!tabItem && tabs.length > 0) {
                    const type = searchParams.get("type")
                    let item = tabs.find(v => v.type == type)
                    if (!item) {
                        item = tabs[0]
                    }
                    onChangeTab(item)
                }
                setIthloading(false)
            }

        }
        const getplmData = async () => {
            setplmloading(true)
            try {
                const res = await getIthWhiteListApi(username)
                if (!res.canFill) {
                    setplmloading(false)
                    return
                }

                const ithres = await getIthWorktimeApi(username)
                if (ithres.error) return
                const item: ITabItem = {
                    title: "填写工时",
                    type: "worktime",
                    log: "工时填报：按钮点击",
                    // url: `https://plm.thape.com.cn/th_keyin?fm=ith&un=${username}`
                    url: "https://ith-workspace.thape.com.cn/ith-worktime/day"
                    // url: "https://ith-workspace.thape.com.cn/workbenchApi/auth/sso-login?redirect_uri=https%3A%2F%2Fith-workspace.thape.com.cn%2Fith-worktime%2Fday"
                }
                tabs.unshift(item)
                if (ithres.status && ithres.status.filled == false) {
                    item.flag = true
                }
                if (!tabItem && tabs.length > 0) {
                    const type = searchParams.get("type")
                    let item = tabs.find(v => v.type == type)
                    if (!item) {
                        item = tabs[0]
                    }
                    onChangeTab(item)
                }
                setTabItemList([...tabs])

            } catch (err) {

            } finally {
                setplmloading(false)
            }

        }

        getIthData()
        getplmData()

    }, [user])

    const addlogData = (type: string) => {
        if (!user) return
        const email = user.email
        const username = email.split('@')[0];

        addLog(username, type)
    }

    const onChangeTab = (v: ITabItem) => {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set("type", v.type);
        setSearchParams(newSearchParams)
        setTabItem(v)

        // addlogData(v.log)
    }

    useEffect(() => {
        const type = searchParams.get("type")
        const item = tabItemList.find(v => v.type == type)
        if (!item) return

        setLoading(true)
        setTabItem(item)
    }, [searchParams])

    const onIframeLoad = () => {
        setLoading(false)
    }

    return (
        <>
            <div className="absolute left-0 top-0 w-full h-ful min-h-screen flex">
                {tabItemList.length > 0 && (
                    <>
                        <div className="shrink-0 px-3 py-4 border-0 border-r border-solid border-gray-200">
                            {tabItemList.map(v => (
                                <div key={v.type} onClick={() => onChangeTab(v)} className={`py-2 px-6 text-center rounded-full cursor-pointer mb-2 hover:font-bold ${v.type === tabItem?.type && "bg-dark-bg text-white"} ${v.flag && "text-red-500"}`}>
                                    {v.title}
                                </div>
                            ))}
                        </div>

                        <div className="flex-1 relative iframe-box">
                            {tabItem?.content ? (
                                tabItem.content
                            ) : (
                                <Spin spinning={loading} wrapperClassName="w-full h-full" className="w-full h-full">
                                    <iframe src={tabItem?.url} className="absolute left-0 top-0 border-none w-full h-full" onLoad={onIframeLoad}></iframe>
                                </Spin>
                            )}
                        </div>
                    </>
                )}
                {!ithloading && !userLoading && !plmloading && tabItemList.length <= 0 && (
                    <>
                        <IthHeader user={user} />
                        <div className="w-full text-center mt-24">
                            <ThEmpty
                                className="mt-4"
                                description={(
                                    <div className="text-black/50 mt-4">
                                        暂无数据
                                    </div>
                                )}
                            />
                        </div>
                    </>

                )}
            </div>
            <Spin spinning={ithloading || userLoading || plmloading} fullscreen />
        </>
    )
}
const IthHeader: React.FC<{ user?: API.USER.Me }> = (props) => {
    const navigate = useNavigate()
    const { user } = props
    const onChangeUser = () => {
        if (isDev) {
            navigate("/auth/jwt")
        } else {
            const url = new URL(
                "/workbenchApi/auth/sso-login",
                window.location.origin
            )
            url.searchParams.append("redirect_uri", window.location.href)
            window.location.href = url.href
        }
    }
    return (
        <div className="fixed top-0 left-0 right-0 h-[55px] z-50 bg-dark-bg grid grid-cols-2 sm:grid-cols-3">
            <div className="h-[55px] flex items-center">

            </div>
            <div className="justify-center sm:flex hidden">
                <div className="w-[230px] h-[55px] pt-[12px]">
                    <a
                        href={documentUtil.getPpmPath()}
                        className="block h-[30px] w-full bg-center bg-contain bg-no-repeat"
                        style={{ backgroundImage: `url(${plmLogo})` }}
                    >
                        {" "}
                    </a>
                </div>
            </div>
            <div className="flex justify-end pr-4">
                {user && (
                    <div className="group relative h-full flex items-center font-medium">
                        <div>
                            <img
                                className="h-8 w-8 rounded-full"
                                src={user.avatar}
                                alt=""
                            />
                        </div>
                        <div className="hidden group-hover:block absolute right-0 top-full px-2 py-2 text-left w-32 bg-white shadow-lg ring-1 ring-black/5 rounded">
                            <div className="text-gray-700 text-sm px-2">
                                {user.chineseName}
                            </div>
                            <div
                                onClick={onChangeUser}
                                className="py-2 px-2 text-left text-gray-700 text-sm rounded cursor-pointer flex flex-col gap-2 border-t border-gray-200 mt-2 hover:bg-gray-100 hover:text-gray-900"
                            >
                                切换用户
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
export default Index